module.exports = __webpack_public_path__ + "static/media/invoice.d10e4e48.svg";